// extracted by mini-css-extract-plugin
module.exports = {"nav-wrap":"style_nav-wrap__1cHs8","nav":"style_nav__qQ8HW","nav-header":"style_nav-header__pwG0O","on":"style_on__1r11T","will-open":"style_will-open__2sqry"};